import httpClient from './httpClient';

const prefix = 'humanresource'

export default {
    async getHumanResourceAll () {
        const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getHumanResourceAll`)
        return dataHumanResource
    },
    async getHumanResourceByCompany () {
        const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getHumanResourceByCompany`)
        return data
    },
    async getHumanResourceByCompanyAndId (id) {
        const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getHumanResourceByCompanyAndId/${id}`)
        return data
    },

    async getFromIdWithRelationById (id) {
        const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getFromIdWithRelationById?id=${id}`)
        return data
    },

    async createHumanResource (body) {
        const { data } = await httpClient({ requiresAuth: true }).post(`${prefix}/createHumanResource`, body)
        return data
    },

    async updateHumanResourcePermissionById (body, id) {
        const { data } = await httpClient({ requiresAuth: true }).put(`${prefix}/updateHumanResourcePermissionById/${id}`, body)
        return data
    },

    async updateHumanResource (body, id) {
        let payload = {
            data: body.data[0]
        }
        const { data } = await httpClient({ requiresAuth: true }).put(`${prefix}/updateHumanResource/${id}`,payload)
        return data
    },

    async updateHumanResourceIsActiveById (body, id) {
        const { data } = await httpClient({ requiresAuth: true }).put(`${prefix}/updateHumanResourceIsActiveById/${id}`, body)
        return data
    },

    async deleteHumanResource (id) {
        const { data } = await httpClient({ requiresAuth: true }).delete(`${prefix}/deleteHumanResource/${id}`)
        return data
    }
}